import getFileName from "./getFileName";

export default async function createMedia({ path, blob }, nodePath, folderReference) {
  const themeID = CodeEditor.Main.themeId();
  const fileName = getFileName({ path });
  let fd = new FormData();
  fd.append("qquuid", CodeEditor.Main.themeUUID());
  fd.append("qqfilename", fileName);
  fd.append("qqtotalfilesize", blob.size);
  fd.append("file", blob, fileName);
  await fetch(`/api/v1/code_editor/upload?folder=${folderReference}&theme_id=${themeID}`, {
    method: "POST",
    headers: new Headers({
      "X-CSRF-Token": CodeEditor.Main.CSRF_TOKEN()
    }),
    credentials: "include",
    body: fd
  });
}
